import clientLogoImg9 from '../assets/images/client-logo/09.png';
import clientLogoImg2 from '../assets/images/client-logo/02.jpg';
import clientLogoImg3 from '../assets/images/client-logo/03.png';
import clientLogoImg4 from '../assets/images/client-logo/04.png';
import clientLogoImg5 from '../assets/images/client-logo/05.png';
import clientLogoImg6 from '../assets/images/client-logo/06.jpg';
import clientLogoImg7 from '../assets/images/client-logo/07.jpg';
import clientLogoImg8 from '../assets/images/client-logo/08.jpg';


import awardLogoImg1 from '../assets/images/award-logo/01.svg';
import awardLogoImg2 from '../assets/images/award-logo/02.svg';
import awardLogoImg3 from '../assets/images/award-logo/03.svg';
import awardLogoImg4 from '../assets/images/award-logo/04.svg';
import awardLogoImg5 from '../assets/images/award-logo/05.svg';
import awardLogoImg6 from '../assets/images/award-logo/06.svg';

import clientLogoLight1 from '../assets/images/client-logo/light/01.svg';
import clientLogoLight2 from '../assets/images/client-logo/light/02.svg';
import clientLogoLight3 from '../assets/images/client-logo/light/03.svg';
import clientLogoLight4 from '../assets/images/client-logo/light/04.svg';
import clientLogoLight5 from '../assets/images/client-logo/light/05.svg';
import clientLogoLight6 from '../assets/images/client-logo/light/06.svg';
import clientLogoLight7 from '../assets/images/client-logo/light/07.svg';

const ClientLogoList = [
    { id: 3, imgSrc: clientLogoImg3, name: "JTI", link: "https://www.jti.com/en/our-company/where-we-operate/northern-western-africa" },
  { id: 4, imgSrc: clientLogoImg4, name: "Philip Morris International", link: "https://www.pmi.com/markets/tunisia/fr" },
  { id: 2, imgSrc: clientLogoImg2, name: "MSC Croisières Tunisie", link: "https://www.msccroisieres.fr/nos-croisieres/destinations/mediterranee/tunisie/la-goulette" },
  { id: 8, imgSrc: clientLogoImg8, name: "Phoenix Mecano Elcom", link: "https://www.facebook.com/pmelcom1/?locale=fr_FR" },
    { id: 5, imgSrc: clientLogoImg5, name: "Bioprotection S.A", link: "https://www.facebook.com/BioprotectionTn/?locale=fr_FR" },

  { id: 7, imgSrc: clientLogoImg7, name: "Salammbô shop", link: "https://salammbo-shop.com/" },
{ id: 1, imgSrc: clientLogoImg9, name: "AWT Audit & Conseil", link: "https://www.awt.com.tn/" },

  { id: 6, imgSrc: clientLogoImg6, name: "Palais Didon Ehpad", link: "https://palaisdidon.fr/" },

];

const AwardLogoList = [
  { id: 1, imgSrc: awardLogoImg1 },
  { id: 2, imgSrc: awardLogoImg2 },
  { id: 3, imgSrc: awardLogoImg3 },
  { id: 4, imgSrc: awardLogoImg4 },
  { id: 5, imgSrc: awardLogoImg5 },
  { id: 6, imgSrc: awardLogoImg6 },
];

const ClientLogoList2 = [
  { id: 1, imgSrc: clientLogoLight1 },
  { id: 2, imgSrc: clientLogoLight2 },
  { id: 3, imgSrc: clientLogoLight3 },
  { id: 4, imgSrc: clientLogoLight4 },
  { id: 5, imgSrc: clientLogoLight5 },
  { id: 6, imgSrc: clientLogoLight6 },
  { id: 7, imgSrc: clientLogoLight7 },
];

export default ClientLogoList;
export { AwardLogoList, ClientLogoList2 };
